import { InputRule } from 'prosemirror-inputrules';

const regex = string =>
  new RegExp(string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'));

const emojis = {
  '-->': '→',
  '<--': '←',
  'O:‑)': '😇',
  '>:-)': '😈',
  ':-))': '😂',
  ':))': '😂',
  ':-)': '🙂',
  ':)': '🙂',
  '=)': '😁',
  '=D': '😁',
  ':‑D': '😄',
  ':D': '😃',
  'x-D': '😆',
  'X‑D': '😆',
  ':‑(': '🙁',
  ':(': '☹️',
  '>:[': '😠',
  '>:(': '😡',
  '>:-(': '😡',
  '>:{': '😖',
  ":'(": '😭',
  ":'-(": '😢',
  ":'‑)": '😂',
  ':‑o': '😮',
  ':-O': '😲',
  ':-*': '😘',
  ';‑)': '😉',
  ':‑/': '😕',
  ':-s': '🤔',
  ':‑|': '😑',
  'B-)': '😎',
};

export function emojiRules() {
  return Object.entries(emojis).map(
    ([key, value]) => new InputRule(regex(key), value),
  );
}
